<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-acoes-planilhas-leilao',
    data () {
      return {
        open: false
      }
    },
    computed: {
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{open: open}"  v-click-out="hide">
    <button class="btn btn-sm btn-black" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-file-excel-o m-r-xs"></i> Gerar Planilha <span class="caret"></span></button>
    <ul class="dropdown-menu no-padder">
      <li>
        <a @click="$emit('gerarPlanilhaExtratoLeilao')" tabindex="2"><i class="fa fa-file-excel-o fa-fw"></i> Planilha de Extrato</a>
      </li>
      <li>
        <a @click="$emit('gerarPlanilha005')" tabindex="2"><i class="fa fa-file-excel-o fa-fw"></i> Transacional 005</a>
      </li>
      <li>
        <a @click="$emit('gerarPlanilhaNotas')" tabindex="2"><i class="fa fa-file-excel-o fa-fw"></i> Planilha de Notas</a>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnAcoesPlanilhasLeilao.vue?25195910